


























import {Vue, Component} from 'vue-property-decorator'

import BaseModal from '../common/BaseModal.vue'

@Component({
  components: {
    BaseModal,
  }
})
export default class CloseModal extends Vue {
}
